import { createContext, useContext } from "react";

export type AuthType = {
  isAuthenticated: any;
  user: any;
  // True when the logged-in user is MANAGER/ADMIN of at least one property, i.e.
  // staff rather than a property owner. Comes from get-profile (`is_manager`) —
  // roles live per-property in property_users, so the User row can't tell us.
  isManager: boolean;
  sendOtpEmail: Function;
  sendOtpPhone: Function;
  login: Function;
  logout: Function;
  loading: any;
  token: any;
  access: any;
  getProfileData: Function;
};
export const AuthContext = createContext<AuthType>({
  isAuthenticated: null,
  user: null,
  isManager: false,
  login: () => {},
  logout: () => {},
  sendOtpEmail: () => {},
  sendOtpPhone: () => {},
  loading: null,
  token: null,
  access: null,
  getProfileData: () => {},
});

export const useAuth = () => useContext(AuthContext);
